export const OfferBackgroundColorsMap = {
    'default': "#ffffff",
    'gray': "#f2f4f7",
    'blue': "#e5f9ff",
    'yellow': "#fff8d2",
    'green': "#e7ffee",
    'orange': "#fff6e1",
};